import { gql } from '@apollo/client';

export const Q_USER_DOCS = gql`
  query ($docId: ID, $VOId: ID) {
    documents(docId: $docId, VOId: $VOId) {
      documentId
      vendorOpportunityId
      source
      docType
      docDescription
      createdBy
      createdDateTime
      docName
      documentCreditSubmission {
        creditSubmissionId
        lenderAccess
      }
    }
  }
`;

export const AGREEMENTS = gql`
  query ($VOId: ID) {
    agreements(VOId: $VOId) {
      agreementId
      docusignEnvelopeId
      name
      agreementStatus
      signedOn
      owner
      accountId
      vendorOpportunityId
      createdDateTime
    }
  }
`;

export const Q_EQUIPMENT = gql`
  query EquipmentsByVOId($id: ID, $VOId: ID) {
    equipments(id: $id, VOId: $VOId) {
      equipmentId
      vendorOpportunityId
      quantity
      newUsed
      year
      make
      model
      serialNumberVin
      additionalDescription
      stockId
      truckClass
      attachments
      wholesaleCost
      totalWholesaleCost
      retailPrice
      mileage
      assetTypeStr
      classType
      cabType
      term
      lenderProduct
      loanType
      hours
      type
      tradeInValue
      amountOwedOnTradeIn
      equipmentIdx
      inventoryItem {
        inventoryId
        status
      }
    }
  }
`;

export const C_HISTORY = gql`
  query getConversationsForVendorOpportunity($vendorOpportunityId: ID!) {
    getConversationsForVendorOpportunity(vendorOpportunityId: $vendorOpportunityId) {
      sid
      vendorOpportunityId
      participants {
        sid
        identity
        userProfileId
        notifyByEmail
        notifyBySMS
        mugshot
        email
        mobilePhoneNumber
        notifyByWhatsapp
        isDealer
        isLender
        isApplicant
      }
      messages {
        participantSid
        userProfileId
        body
        author
        delivery {
          total
          read
          sent
          delivered
          failed
          undelivered
        }
      }
      task {
        regarding
      }
      topic
      createdAt
      taskId
    }
  }
`;

export const START_FAST_TRACK_PROCESS = gql`
  query ($vendorOpportunityDatabaseId: ID!, $fastTrackInputs: JSON) {
    startFastTrackProcess(vendorOpportunityDatabaseId: $vendorOpportunityDatabaseId, fastTrackInputs: $fastTrackInputs)
  }
`;

export const QUERY_TASKS = gql`
  query VendorOpportunityTask($VOId: ID!, $limit: Int) {
    vendorOpportunityTask(VOId: $VOId, limit: $limit) {
      taskId
      vendorOpportunityId
      regarding
      status
      assignedToUserProfileId
      assignedToAccountId
      assignedByUserProfileId
      assignedByAccountId
      notes
      priority
      createdBy
      completedDateTime
      dueDateTime
      createdDateTime
      assignedByUser
      assignedByAccount
      assignedToUser
      assignedToAccount
      notifyByEmail
      notifyByText
      notifyAssignorOnReminder
      notificationContactIds
      lastReminderSent
      nextReminder
      assignedToApplicant
      assignedBySystem
      ownerPgId
      financeProgramId
      taskItems {
        taskItemId
        type
        docType
        taskAssignorNotes
        taskAssigneeNotes
        doc {
          documentId
          vendorOpportunityId
          source
          docType
          docDescription
          createdBy
          docName
        }
      }
      reference {
        referenceId
        tasksCompletionData
      }
    }
  }
`;

export const QUERY_VENDOR_PROFILES_ASSOCIATED_TO_LENDER = gql`
  query vendorProfilesByDynamicsLenderAccountId($dynamicsAccountId: ID!) {
    vendorProfilesByDynamicsLenderAccountId(dynamicsAccountId: $dynamicsAccountId) {
      id
      dynamicsId
      name
    }
  }
`;

export const SYNC_INVENTORY = gql`
  mutation SyncInventoryItemToVo($vendorOpportunityId: ID!, $stockNumber: String, $vin: String) {
    syncInventoryItemToVo(input: { vendorOpportunityId: $vendorOpportunityId, stockNumber: $stockNumber, vin: $vin }) {
      equipmentId
      success
      message
    }
  }
`;

export const SEARCH_INVENTORY = gql`
  query SearchInventory($input: InventorySearchInput!) {
    inventorySearch(input: $input) {
      vin
      source
      stockNumber
      description
      year
      make
      model
      mileage
      condition
      retailPrice
    }
  }
`;

export const FETCH_INVENTORY_SEARCH_ACCESS = gql`
  query IntegrationSettingsValues($input: IntegrationSettingsValuesInput!) {
    integrationSettingsValues(input: $input) {
      accountId
    }
  }
`;

export const SYNC_DEAL_INFO_TO_VO = gql`
  mutation SyncDealInfoToVo($input: SyncDealInfoToVoInput!) {
    syncDealInfoToVo(input: $input) {
      externalDealId
      success
      message
      previewOnly
      syncDataByProperty {
        name
        valueBeforeSync
        valueAfterSync
        message
        syncDataByProperty {
          name
          valueBeforeSync
          valueAfterSync
          message
          syncDataByProperty {
            name
            valueBeforeSync
            valueAfterSync
            message
          }
        }
      }
    }
  }
`;
